import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import BestWork from './pages/BestWork';
import Packages from './pages/Packages';
import Experience from './pages/Experience';
import About from './pages/About';
import Testimonials from './pages/Testimonials';
import Contact from './pages/Contact';
import PdfPreview from './pages/PdfPreview';
import ServicePage from './pages/ServicePage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/best-work" element={<BestWork />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/about" element={<About />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/:service" element={<ServicePage />} />
          <Route path="/pdf-preview" element={<PdfPreview />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
